import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";
import getCigUpcomingSessions, { CigUpcomingSession } from "../getCigUpcomingSessions";

const useGetUpcomingSessions = (autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<CigUpcomingSession[]>([]);

  const send = useCallback(async () => {
    setLoading();
    try {
      const bookings = await getCigUpcomingSessions();
      return setSuccess(bookings);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetUpcomingSessions;
